import React, { useLayoutEffect, useRef } from 'react';
import { Box, Typography, Link } from '@mui/material';
import ScienceIcon from '@mui/icons-material/Science';
import { isTestEnvironment } from '../utils/apiConfig';
import { zetTestbalkHoogte } from '../utils/testbalk';

// Waarschuwt op test.fullframe.nl dat dit niet productie is, met één klik naar
// de echte omgeving. Geen statusteksten: die verouderen stil.
const TestEnvironmentBanner = () => {
  // De tabtitel ("🧪 TEST · … · Toolframe") zet App per pagina, via browserTitel().

  // Hoogte doorgeven aan de drawers rechts (utils/testbalk), ook als de balk op een smal
  // scherm naar twee regels springt.
  const balkRef = useRef(null);
  useLayoutEffect(() => {
    const balk = balkRef.current;
    if (!balk) return undefined;
    const meet = () => zetTestbalkHoogte(balk.getBoundingClientRect().height);
    meet();
    const waarnemer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(meet) : null;
    waarnemer?.observe(balk);
    return () => { waarnemer?.disconnect(); zetTestbalkHoogte(null); };
  }, []);

  if (!isTestEnvironment) return null;

  return (
    <Box
      ref={balkRef}
      role="status"
      aria-live="polite"
      sx={{
        position: 'sticky',
        top: 0,
        // Onder MUI-modals (1300): drawers/dialogs (o.a. het Offerteregels-
        // paneel) horen óver de banner te vallen, niet erachter weg te vallen.
        zIndex: 1250,
        bgcolor: '#fee2e2',
        color: '#991b1b',
        borderBottom: '2px solid #dc2626',
        px: 2,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        flexWrap: 'wrap',
        textAlign: 'center',
      }}
    >
      <ScienceIcon sx={{ fontSize: 18 }} />
      <Typography component="span" sx={{ fontWeight: 900, fontSize: '1.15rem', letterSpacing: '0.12em', color: 'inherit', lineHeight: 1 }}>
        TEST
      </Typography>
      <Link
        href="https://intern.fullframe.nl"
        sx={{ fontWeight: 700, color: 'inherit', textDecorationColor: 'currentColor' }}
      >
        Naar intern.fullframe.nl →
      </Link>
    </Box>
  );
};

export default TestEnvironmentBanner;
